import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/CharityFair.css';

function Navbar() {
  return (
    <nav className="bg-gradient-to-r from-[#e91e63] to-[#ad1457] text-white p-4 shadow-lg relative overflow-hidden">
      <div className="container mx-auto flex items-center justify-center relative z-10">
        <Link to="/" className="text-2xl font-bold text-white flex items-center gap-3 hover:scale-105 transition-transform">
          <span className="text-3xl">🎗️</span>
          <span className="text-shadow-lg">Благотворительная ярмарка</span>
          <span className="text-3xl">💖</span>
        </Link>
      </div>
    </nav>
  );
}

export default Navbar;
